/** @format */

import { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { EventContext } from '../../Contexts/EventContext';
import Master from '../Layouts/Master';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';

const buildQueryString = (locationSearch) => {
  const params = new URLSearchParams(
    locationSearch.startsWith('?') ? locationSearch.slice(1) : locationSearch,
  );
  params.set('include_inactive', '1');
  return params.toString();
};

const PositionList = () => {
  const eventContext = useContext(EventContext);
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [positionRemoveId, setPositionRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getPositions();
  }, [search]);

  const getPositions = async () => {
    setLoading(true);
    await useApi.get(
      `/position?${buildQueryString(search)}`,
      {},
      (res) => {
        eventContext.positions = res.data;
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const removePosition = async (positionId) => {
    setRemoveLoading(true);
    await useApi.delete(
      `/position/${positionId}`,
      {},
      (res) => {
        const item = res.data?.data;
        if (item?.is_active === false) {
          success('سمت در ثبت‌نام‌ها استفاده شده و غیرفعال شد');
        } else {
          success('سمت با موفقیت حذف شد');
        }
        setRemoveLoading(false);
        setModalIsOpen(false);
        getPositions();
      },
      () => {
        setRemoveLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست سمت‌ها
          </h1>
        </div>
        <Link
          to='/panel/setting/positions/create'
          className='d-flex flex-row btn btn-outline-info'
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>افزودن سمت</span>
        </Link>
      </div>
      <div className='w-100 overflow-auto'>
        {eventContext.positions?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>عنوان</th>
                <th>ترتیب</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.positions?.data?.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.name}</td>
                  <td>{item.sort_order ?? 0}</td>
                  <td>
                    {item.is_active ? (
                      <span className='badge badge-success badge-pill p-2'>
                        فعال
                      </span>
                    ) : (
                      <span className='badge badge-secondary badge-pill p-2'>
                        غیرفعال
                      </span>
                    )}
                  </td>
                  <td>
                    <div className='d-flex flex-row'>
                      <Link
                        to={`/panel/setting/positions/edit/${item.id}`}
                        className='mx-2'
                      >
                        ویرایش
                      </Link>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setPositionRemoveId(item.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3'>
            <span className='f-13 font-weight-bold text-secondary'>
              {loading ? 'در حال بارگذاری...' : 'سمتی ثبت نشده است'}
            </span>
          </div>
        )}
      </div>
      <Pagination
        totalPage={eventContext.positions?.meta?.pagination?.total_pages}
        basePath='/panel/setting/positions'
        search={buildQueryString(search)}
      />
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span>آیا از حذف این سمت مطمئنید؟</span>
        </div>
        <p className='f-12 my-2 text-white-50'>
          اگر در ثبت‌نام‌ها استفاده شده باشد، فقط غیرفعال می‌شود.
        </p>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removePosition(positionRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default PositionList;
